
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Spinner } from "reactstrap";

const Authmiddleware = (props) => {
  const location = useLocation();
  const { authLoading, isAuthenticated, user } = useSelector(state => state.Login);

  if (authLoading) {
    return (
      <div style={{ width: "100%", height: "100dvh", display: "grid", placeItems: "center" }}>
        <Spinner />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  if (
    user?.mustChangePassword &&
    location.pathname !== "/change-password" &&
    location.pathname !== "/logout"
  ) {
    return <Navigate to="/change-password" replace />;
  }

  return <>{props.children}</>;
};

export default Authmiddleware;
